import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ContentDocumentComponent } from '../components/content-document/content-document.component';
import { ContentFavoriteComponent } from '../components/content-favorite/content-favorite.component';
import { ContentImagesComponent } from '../components/content-images/content-images.component';
import { ContentShareComponent } from '../components/content-share/content-share.component';
import { ContentAdatper } from '../content.adatper';

@Component({
  selector: 'app-content-detail',
  templateUrl: './content-detail.component.html',
  imports: [
    CommonModule,
    ContentDocumentComponent,
    ContentFavoriteComponent,
    ContentShareComponent,
    ContentImagesComponent,
  ],
})
export class ContentDetailComponent extends ContentAdatper {}
